import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { auth } from './firebase';
import { connect } from "react-redux"
import { call, put, takeEvery } from "redux-saga/effects"

const FIREBASE_USER_CHANGED = 'FIREBASE_USER_CHANGED';
const FIREBASE_SIGNOUT_REQUESTED = 'FIREBASE_SIGNOUT_REQUESTED';
const FIREBASE_SIGNOUT_FAILED = 'FIREBASE_SIGNOUT_FAILED';
const FIREBASE_ACCOUNT_LOADED = 'FIREBASE_ACCOUNT_LOADED';
const FIREBASE_RECEIVEGROUPS_LOADED = 'FIREBASE_RECEIVEGROUPS_LOADED';

export function firebaseAuthStart(store) {
  auth.onAuthStateChanged((user) => {
    store.dispatch({ type: FIREBASE_USER_CHANGED, user })
  })
}

export function actionSignout() {
  return {
    type: FIREBASE_SIGNOUT_REQUESTED
  }
}

export function actionAccountLoaded(account) {
  return {
    type: FIREBASE_ACCOUNT_LOADED,
    payload: account
  }
}

export function actionReceiveGroupsLoaded(groups) {
  return {
    type: FIREBASE_RECEIVEGROUPS_LOADED,
    payload: groups
  };
}

function* signOut(action) {
  try {
    console.log('Signing out, auth=', auth)
    yield call(() => auth.signOut())
  } catch (e) {
    // TODO: handle this error case
    console.log('Signout failed with error', e);
    yield put({ type: FIREBASE_SIGNOUT_FAILED, message: e.message });
  }
}

export function* authSaga() {
  yield takeEvery(FIREBASE_SIGNOUT_REQUESTED, signOut);
}

export function firebaseReducer(state = { user: null, account: null, receiveGroups: null, logged: false }, action) {
  switch (action.type) {
    case FIREBASE_USER_CHANGED:
      return { ...state, user: action.user, logged: !!action.user };
    case FIREBASE_ACCOUNT_LOADED:
      return { ...state, account: action.payload }
    case FIREBASE_RECEIVEGROUPS_LOADED:
      return { ...state, receiveGroups: action.payload }
    default:
      return state;
  }
}

export function getUser(state) {
  return state.firebase.user;
}

export class AuthSwitchRaw extends Component {
  constructor(props) {
    super(props);

    if (props.children.length !== 2) {
      throw new Error("LOGGED OUT / LOGGED IN expected");
    }
  }

  render() {
    const { logged } = this.props;

    if (!logged) {
      return this.props.children[0];
    } else {
      return this.props.children[1];
    }
  }
}

AuthSwitchRaw.propTypes = {
  logged: PropTypes.bool
}

export const AuthSwitch = connect(
  state => ({
    logged: state.firebase.logged
  })
)(AuthSwitchRaw);





// WEBPACK FOOTER //
// ./src/data/auth.js